import translation from "./translation";

const i18nResource = {
  translation,
};

export default i18nResource;
